<Modal
  title="Change email address"
  actionTitle="Update"
  {isLoading}
  on:close={() => ($uiState.activeModal = undefined)}
  on:action={() => apply()}>
  
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="label">Current email</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" disabled bind:value={userId} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="label">New email</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" bind:value={newId} />
        </div>
      </div>
    </div>
  </div>

  {#if errorMessage}
    <div class="block notification is-danger is-light">{errorMessage}</div>
  {/if}
</Modal>

<script lang="ts">
  export let userId : string;

  import { logging } from '../../../../../lib/logging';
  import { uiState } from "../../../../../lib/uiState";
  import Modal from "../../../../_components/Modal.svelte";
  import _ from 'lodash';
  import { goto, url} from "@sveltech/routify";

  let errorMessage :string;
  let isLoading :boolean;

  let newId: string; 

  async function apply() {
    isLoading = true;

    try {

      let firebase = window.firebase;

      await firebase
          .functions()
          .httpsCallable('api-account-updateuseremail')({ userId, newId } as UpdateUserEmailParams);

      // Page needs a refresh (using $goto does not work)
      // Not sure why?
      window.location = $url('./user/' + newId); 
      
    }
    catch(err: any) {
      logging.report(err.toString());
      errorMessage = err.toString();
    }
    finally {
      isLoading = false
    }

  }
</script>
